import { getPendo } from '../utils/pendo/pendo.utils';
import { trackUserpilotEvent } from '../utils/userpilot/userpilot.utils';

type TrackEvent = (eventName: string, eventProperties?: Record<string, string | number | string[] | boolean | null>) => void;

export const trackEvent: TrackEvent = (eventName, eventProperties) => {
  getPendo()?.track(eventName, eventProperties);
  trackUserpilotEvent(eventName, eventProperties);
};
